module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/feature-2-icon-2.png?2b323258";